import { AppShell } from '../../layout/AppShell';
import type { ShellProps } from '../types';

// Classic skin — the original single-sidebar AppShell, unchanged. It builds the collapsible
// rail from every module's nav, the topbar (⌘K / notifications / theme / user menu), the
// breadcrumbs and the Inspector dock. The only addition is the skin switcher, which lives in
// the shared UserMenu the AppShell now renders. Kept as a thin wrapper so the standalone
// AppShell export (and its tests) keep working verbatim.

export function ClassicShell({ brand, brandShort, footer, badges, sections }: ShellProps) {
  return <AppShell brand={brand} brandShort={brandShort} footer={footer} badges={badges} sections={sections} />;
}
